import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ShiftProvider } from "./contexts/ShiftContext";
import ProtectedRoute from "./components/ProtectedRoute";
import WelcomeVideoModal from "./components/WelcomeVideoModal";
import Login from "./pages/Login";
import ActivityFeed from "./pages/ActivityFeed";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import ProfilePage from "./pages/ProfilePage";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ShiftProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/feed" replace />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/feed"
                element={
                  <ProtectedRoute>
                    <ActivityFeed />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/apps"
                element={
                  <ProtectedRoute>
                    <EmployeeDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={<Navigate to="/feed" replace />}
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute managerOrAdmin>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/feed" replace />} />
            </Routes>
          </BrowserRouter>
          <WelcomeVideoModal />
          <Toaster position="top-right" richColors />
        </ShiftProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
